import { useMetaTags as useMetaTagsBase } from 'react-metatags-hook';

export function useMetaTags(config, dependencies = [config]) {
    useMetaTagsBase(config, dependencies);
}
